// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --cta-color: #4577b6;
  --cta-color-darker: #137a8f;
  --cta-color-darkest: #1c4d57;
  --cta-color-hover: #50b37b;
  --light-border: #bbb;
  --very-light-border: #ccc;
  --link-color: rgb(19, 122, 143);
}
.pdf-preview {
  width: 100%;
  height: 40em;
}

.pdf-preview-hidden {
  height: 0px;
  width: 0px;
  display: none;
}

.pdf-preview-visible {
  height: auto;
  width: auto;
  display: block;
}
.pdf-dl-on-its-way {
  color: green;
}
.pdf-dl-is-on-its-way {
  color: green;
  font-weight: bold;
}
.pdf-pls-b-patient {
  color: #567ac6;
  font-size: 1em;
}
.pdf-check-ur-dls {
  color: #567ac6;
}

.PropertySingleLineHeaderWrapper .share-button-generic {
  border: 1px solid black;
  /*background-color: #d1ae6d;*/
  /*background-color: #3a4e48;*/
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 11px;
  color: black;
  padding-top: 0.8em;
}
.PropertySingleLineHeaderWrapper .pdf-cancel {
  background-color: #3a4e49;
  color: white;
  text-transform: uppercase;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  padding: 1em 3em;
  margin: 0 auto;
}
.PropertySingleLineHeaderWrapper .pdf-cancel:hover {
  font-weight: 1000;
  background-color: red;
}
.PropertySingleLineHeaderWrapper .pdf-is-generating {
  padding: 1em;
  border: 3px dotted #3a4e48;
  background-color: #ddd;
  display: flex;
  flex-direction: column;
  text-align: center;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 45%;
  height: 50vh;
  margin-top: 10%;
  margin-left: 25%;
}
.zi-top {
  z-index: 40 !important;
}
.PropertySingleLineHeaderWrapper .pdf-progress {
  font-size: 15px;
}
#pdf-blocker-ui {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.8;
  z-index: 10 !important;
}
.share-button-copy-icon {
  width: 1.2em;
}
.share-modal-buttons {
  width: 4em;
  display: flex;
  flex-direction: row;
  /*
  align-items: start;
  justify-content: start;
  */
  align-items: center;
  justify-content: center;
  width: 100%;
}
.share-link {
  font-size: 11px;
  border: 1px solid grey;
  padding: 0.3em;
  width: 100%;
}
.PropertySingleLineHeaderWrapper .link-loading {
  background-color: var(--cta-color);
  color: white;
  font-family: Roboto, sans-serif;
  font-weight: bold;
  padding-top: 0.4em;
}
.PropertySingleLineHeaderWrapper .link-cancel {
  background-color: red;
  color: white;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: bold;
  padding-top: 0.4em;
}
.psl-hint-message {
  color: #3a4e49;
  color: #567ac6;
  font-family: Roboto, sans-serif;
  font-size: 16px;
}

.choose-what-to-print {
}
.psl-hidden {
  display: none;
  height: 0px;
  padding: 0em;
  margin: 0em;
}
.mandatory-space-message {
  min-height: 1em;
}
.icons-select-wrapper {
  width: 100%;
}
.icons-select-wrapper button {
  width: 10em;
}
.smb-icons {
  display: flex;
  flex-direction: column;
}
.pslh-copy-inputs {
  display: flex;
  flex-direction: row;
  height: 30px;
}
.pslh-copy-inputs input {
  color: #444;
}
.pslh-copy-btn {
  background-color: #4b8ffe;
  padding: 0em;
  margin: 0em;
  padding-top: 0em !important;
  padding-left: 0.4em;
  padding-right: 0.4em;
  font-weight: 900;
  color: white !important;
}
.share-link-icons {
  font-family: sans-serif;
  font-weight: 900;
  background-color: #4b8ffe;
  background-color: var(--cta-color-hover);
  color: white !important;
  font-size: 1.2em !important;
  padding-top: 0.4em !important;
  padding-bottom: 0.4em !important;
  padding-right: 0.8em !important;
}
.share-link-single-line {

}
.pslh-minify-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  max-width: 26em;
}
.copied-notification-text {
  color: green;
}

.tsm-unchecked-wrapper {
  color: white;
}
.thumb-select-me-unselected {
  background-color: #4577b6;
  color: white;
}
.get-shareable-link {
  padding-top: 0.0em !important;
  padding-bottom: 0em !important;
}
.pslh-share {
  padding-top: 0.4em !important;
  padding-bottom: 0.4em !important;
}
.lombardo-hidden {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/PropertySingleLineHeader.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB;;;GAGC;EACD,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,cAAc;EACd,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;AACA;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;AACjC;AACA;;AAEA;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,aAAa;AACf","sourcesContent":[":root {\n  --cta-color: #4577b6;\n  --cta-color-darker: #137a8f;\n  --cta-color-darkest: #1c4d57;\n  --cta-color-hover: #50b37b;\n  --light-border: #bbb;\n  --very-light-border: #ccc;\n  --link-color: rgb(19, 122, 143);\n}\n.pdf-preview {\n  width: 100%;\n  height: 40em;\n}\n\n.pdf-preview-hidden {\n  height: 0px;\n  width: 0px;\n  display: none;\n}\n\n.pdf-preview-visible {\n  height: auto;\n  width: auto;\n  display: block;\n}\n.pdf-dl-on-its-way {\n  color: green;\n}\n.pdf-dl-is-on-its-way {\n  color: green;\n  font-weight: bold;\n}\n.pdf-pls-b-patient {\n  color: #567ac6;\n  font-size: 1em;\n}\n.pdf-check-ur-dls {\n  color: #567ac6;\n}\n\n.PropertySingleLineHeaderWrapper .share-button-generic {\n  border: 1px solid black;\n  /*background-color: #d1ae6d;*/\n  /*background-color: #3a4e48;*/\n  font-family: Roboto, sans-serif;\n  font-weight: 500;\n  font-size: 11px;\n  color: black;\n  padding-top: 0.8em;\n}\n.PropertySingleLineHeaderWrapper .pdf-cancel {\n  background-color: #3a4e49;\n  color: white;\n  text-transform: uppercase;\n  font-family: Roboto, sans-serif;\n  font-size: 16px;\n  padding: 1em 3em;\n  margin: 0 auto;\n}\n.PropertySingleLineHeaderWrapper .pdf-cancel:hover {\n  font-weight: 1000;\n  background-color: red;\n}\n.PropertySingleLineHeaderWrapper .pdf-is-generating {\n  padding: 1em;\n  border: 3px dotted #3a4e48;\n  background-color: #ddd;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  width: 45%;\n  height: 50vh;\n  margin-top: 10%;\n  margin-left: 25%;\n}\n.zi-top {\n  z-index: 40 !important;\n}\n.PropertySingleLineHeaderWrapper .pdf-progress {\n  font-size: 15px;\n}\n#pdf-blocker-ui {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: black;\n  opacity: 0.8;\n  z-index: 10 !important;\n}\n.share-button-copy-icon {\n  width: 1.2em;\n}\n.share-modal-buttons {\n  width: 4em;\n  display: flex;\n  flex-direction: row;\n  /*\n  align-items: start;\n  justify-content: start;\n  */\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.share-link {\n  font-size: 11px;\n  border: 1px solid grey;\n  padding: 0.3em;\n  width: 100%;\n}\n.PropertySingleLineHeaderWrapper .link-loading {\n  background-color: var(--cta-color);\n  color: white;\n  font-family: Roboto, sans-serif;\n  font-weight: bold;\n  padding-top: 0.4em;\n}\n.PropertySingleLineHeaderWrapper .link-cancel {\n  background-color: red;\n  color: white;\n  font-family: Roboto, sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  padding-top: 0.4em;\n}\n.psl-hint-message {\n  color: #3a4e49;\n  color: #567ac6;\n  font-family: Roboto, sans-serif;\n  font-size: 16px;\n}\n\n.choose-what-to-print {\n}\n.psl-hidden {\n  display: none;\n  height: 0px;\n  padding: 0em;\n  margin: 0em;\n}\n.mandatory-space-message {\n  min-height: 1em;\n}\n.icons-select-wrapper {\n  width: 100%;\n}\n.icons-select-wrapper button {\n  width: 10em;\n}\n.smb-icons {\n  display: flex;\n  flex-direction: column;\n}\n.pslh-copy-inputs {\n  display: flex;\n  flex-direction: row;\n  height: 30px;\n}\n.pslh-copy-inputs input {\n  color: #444;\n}\n.pslh-copy-btn {\n  background-color: #4b8ffe;\n  padding: 0em;\n  margin: 0em;\n  padding-top: 0em !important;\n  padding-left: 0.4em;\n  padding-right: 0.4em;\n  font-weight: 900;\n  color: white !important;\n}\n.share-link-icons {\n  font-family: sans-serif;\n  font-weight: 900;\n  background-color: #4b8ffe;\n  background-color: var(--cta-color-hover);\n  color: white !important;\n  font-size: 1.2em !important;\n  padding-top: 0.4em !important;\n  padding-bottom: 0.4em !important;\n  padding-right: 0.8em !important;\n}\n.share-link-single-line {\n\n}\n.pslh-minify-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  max-width: 26em;\n}\n.copied-notification-text {\n  color: green;\n}\n\n.tsm-unchecked-wrapper {\n  color: white;\n}\n.thumb-select-me-unselected {\n  background-color: #4577b6;\n  color: white;\n}\n.get-shareable-link {\n  padding-top: 0.0em !important;\n  padding-bottom: 0em !important;\n}\n.pslh-share {\n  padding-top: 0.4em !important;\n  padding-bottom: 0.4em !important;\n}\n.lombardo-hidden {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
